<template>
	<div class="container-fluid">

		<div class="row">
			<div class="col-md-5 col-lg-5 col-xl-5 mb-4">
				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Existing Projects</h4>
					</div>
					<div class="card-body">
						<p>Here is a list of projects, which you own, or otherwise have access to:</p>
						<ul class="list-unstyled mt-3 mb-4">
							<li v-for="( project, index ) in projectList" :key="index">
								<!--<a href="javascript:void(0)" @click.prevent="selectProject(project)">{{project.title}} ({{project.$id}})</a>-->
								<router-link :to="'/nodes/'+ nodeId +'/projects/'+ project.$id"><b>{{project.title}}</b> ({{project.$id}})</router-link>
							</li>
						</ul>
						<button class="btn btn-primary" @click.prevent="loadProjects( true )"><i class="fas fa-sync-alt"></i> Refresh</button>
						<p class="mt-4 mb-0 text-muted"><small><strong>Upcoming:</strong> we will soon offer project search and browsing capabilities.</small></p>
					</div>
				</div>
			</div>
			
			<div class="col-md-7 col-lg-7 col-xl-7 mb-4">

				<div class="card shadow-sm mb-4">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">New Project</h4>
					</div>
					<div class="card-body">
						<form autocomplete="off">
							<div class="form-group">
								<label for="newProject_id">ID (System Name)</label>
								<input v-model="newProject.$id" type="text" class="form-control" id="newProject_id" aria-describedby="newProject_idHelp" placeholder="Enter ID">
								<small id="newProject_idHelp" class="form-text text-muted">Unique ID with only lowercase letters, numbers and '_' (e.g. "joe_project_2")</small>
							</div>
							<div class="form-group">
								<label for="newProject_title">Title</label>
								<input v-model="newProject.title" type="text" class="form-control" id="newProject_title" aria-describedby="newProject_titleHelp" placeholder="Enter title">
								<small id="newProject_titleHelp" class="form-text text-muted">Descriptive title (e.g. "Joe's Project #2")</small>
							</div>
							<div class="form-group">
								<label for="newProject_desc">Description</label>
								<textarea v-model="newProject.description" type="text" class="form-control" id="newProject_desc" aria-describedby="newProject_descHelp" placeholder="Enter description" rows="2"></textarea>
								<small id="newProject_descHelp" class="form-text text-muted">Descriptive details (e.g. "This project is created for testing.")</small>
							</div>
							<div class="form-check mb-3">
								<input v-model="newProject.public" type="checkbox" class="form-check-input" id="newProject_public">
								<label class="form-check-label" for="newProject_public" aria-describedby="newProject_publicHelp">Public <small class="text-muted">(discoverable by any valid API key or account)</small></label>
							</div>

							<div class="form-group">
								<label>Sharing Permissions</label>
								<table class="table table-bordered table-hover table-responsive">
									<thead>
										<tr>
											<th scope="col" style="width: 100%;">Account Name <em class="text-muted">(ID)</em></th>
											<th scope="col" class="text-center" style="min-width: 80px;"><em>None</em></th>
											<th scope="col" class="text-center" style="min-width: 80px;">Read</th>
											<th scope="col" class="text-center" style="min-width: 80px;">Write</th>
											<th scope="col" class="text-center table-danger" style="min-width: 80px;">Admin</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="account in accountsList" :key="account.$id">
											<th scope="row" class="font-weight-normal">{{account.name}} <em class="text-muted">({{account.$id}})</em></th>
											<td class="text-center"><input v-model="newProjectSharing[account.$id]" type="radio" :value="undefined" :name="account.$id"></td>
											<td class="text-center"><input v-model="newProjectSharing[account.$id]" type="radio" value="read" :name="account.$id"></td>
											<td class="text-center"><input v-model="newProjectSharing[account.$id]" type="radio" value="write" :name="account.$id"></td>
											<td class="text-center table-danger"><input v-model="newProjectSharing[account.$id]" type="radio" value="admin" :name="account.$id"></td>
										</tr>
										<tr v-for="( checkedValue, accountId ) in manualAccountsProjectSharing" :key="accountId" v-if="accountsList.length <= 1">
											<th scope="row" class="font-weight-normal">{{checkedValue}}
												<em v-if="checkedValue != accountId" class="text-muted">({{accountId}})</em>
											</th>
											<td class="text-center"><input v-model="newProjectSharing[accountId]" type="radio" :value="undefined" :name="accountId"></td>
											<td class="text-center"><input v-model="newProjectSharing[accountId]" type="radio" value="read" :name="accountId"></td>
											<td class="text-center"><input v-model="newProjectSharing[accountId]" type="radio" value="write" :name="accountId"></td>
											<td class="text-center table-danger"><input v-model="newProjectSharing[accountId]" type="radio" value="admin" :name="accountId"></td>
										</tr>
										<tr v-if="accountsList.length <= 1">
											<td colspan="5">
												<div class="form-row">
													<div class="col">
														<label for="manualAddUser" class="col-form-label">Add known username:</label>
													</div>
													<div class="col">
														<input v-model="userCheckName" id="manualAddUser" type="text" pattern="[a-zA-Z0-9_]+" class="form-control" placeholder="Enter ID or Username">
													</div>
													<div class="col">
														<button class="btn btn-secondary" @click.prevent="addManualShareUser( )"><i class="fas fa-plus"></i> Add User</button>
													</div>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<button class="btn btn-success mt-4" @click.prevent="createProjectFromData"><i class="fas fa-star"></i> Create New Project</button>
						</form>
					</div>
				</div>

				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Create New Project (JSON)</h4>
					</div>
					<div class="card-body">
						For developers and testers:
						<div id="editor"></div>
						<button class="btn btn-success mt-4" @click.prevent="createProjectFromEditor"><i class="fas fa-star"></i> Create</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import 'ace-builds';
import 'ace-builds/webpack-resolver';

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import _ from 'lodash';

export default {
	name: "projects-view",
	props: [ 'nodeId' ],
	data() {
		return {
			newProject:
			{
				$id : "",
				$schema : "sys:project.",
				title : "",
				description : "",
				public : false,
				sharing : { },
			},
			newProjectSharing: { },
			manualAccountsProjectSharing: { },
			userCheckName: "",
			projectList : []
		};
	},
	watch:
	{
		newProjectSharing:
		{
			deep: true,
			handler: function( newValue, oldValue )
			{
				let sharing = { };
				for( let account in newValue )
				{
					let role = newValue[account];
					
					if( role == 'read' || role == 'write' || role == 'admin' )
						sharing[account] = { [role] : true };
					
				}
				this.$set( this.newProject, 'sharing', sharing );
			}
		},
		newProject:
		{
			handler: function( newValue, oldValue ) { this.editor.setValue( JSON.stringify( this.newProject, null, 2 ), -1 ); },
			deep : true
		}
	},
	components: { },
	computed:
	{
		currentSession: function( )
		{
			try {
				let sessionGuid = this.activeSession( this.nodeId );
				let [ sNode, sKey ] = sessionGuid.split( "/" );
				let session = this.session( sessionGuid );
				return session;
			} catch( err ) { }
			return null;
		},
		...mapGetters( "projects", {
			projects: "projects", // map STATE projects/all to "projects" AS A FUNCTION, which requires the nodeId as input!
		}),
		...mapGetters( "accounts", {
			accounts: "accounts",
			account: "account"
		}),
		...mapGetters( "authentication", {
			activeSession: "activeSession",
			session: "session"
		}),
		accountsList( ) {
			return this.accounts( this.nodeId );
		}
	},
	methods: {
		async addManualShareUser( checkName )
		{
			checkName = checkName || this.userCheckName;
			if( !checkName )
				return alert( "You must provide a username or ID to add a user." );
			let account = await this.checkAccount( { nodeId : this.nodeId, checkName } );
			if( !account )
				return alert( "No account found with this username or ID" );
			if( this.account( this.nodeId, account.$id ) )
				return alert( "This account is already listed." );
			console.log( "ACCOUNT:", account );
			let id = account.$id;
			if( this.manualAccountsProjectSharing.hasOwnProperty( id ) )
				return alert( "This account is already in the sharing list:\nID: "+ id );
			this.$set( this.manualAccountsProjectSharing, id, this.userCheckName );
			this.userCheckName = "";
		},
		...mapActions({
			listProjects: "projects/list",
			createProject: "projects/create",
			listAccounts: "accounts/list",
			checkAccount: "accounts/checkAccount",
		}),
		async checkMySession( )
		{
			try {
				let sessionGuid = this.$store.getters['authentication/activeSession']( this.nodeId );
				return await this.$store.dispatch( 'authentication/checkSession', { nodeId : this.nodeId, sessionKey : sessionGuid } );
			} catch( err ) { console.error( err ); return null; }
		},
		getProjects( )
		{
			return this.projects( this.nodeId );
		},
		async createProjectFromData( )
		{
			await this.createNewProject( this.newProject );
		},
		async createProjectFromEditor( )
		{
			// TODO: Set loading overlay
			let project;

			try {
				project = JSON.parse( this.editor.getValue( ) );
			} catch( err ) {
				alert( "Project format issue:\n"+ err.message );
				console.error( err );
				return;
			}

			await this.createNewProject( project );
		},
		async createNewProject( project )
		{
			if( !project.$id ) return alert( "Must define a project ID ('$id' field)" );
			if( !project.title ) return alert( "Must define a project Title ('title' field)" );

			try {
				let result = await this.createProject( { nodeId : this.nodeId, newProject : project } );
				if( !result.$id )
					throw new Error( "Result from project creation came back without an ID!" );
				this.projectList = this.projects( this.nodeId );
				this.$router.push( { name : 'project', params : { nodeId : this.nodeId, projectId : result.$id } } );
				// TODO: close loading overlay
			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "Project creation failed:", err );
				alert( "Project creation failed!\n"+ err.message );
				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
			}
		},
		async loadProjects( nocache )
		{
			try {
				await this.listProjects( { nodeId : this.nodeId, nocache : nocache } );
				this.projectList = this.projects( this.nodeId );
			} catch( err ) {
				if( err.response && ( err.response.status === 401 ) )
				{
					console.warn( "Session expired, invalid or missing.." );
					this.checkMySession( );
				}
				else
					throw err;
			}
		},
	},
	async created( )
	{
		this.projectList = this.getProjects( );	// Get projects from cache.
		await this.loadProjects( true );	// Reload projects in the background to make sure we have the latest.
	},
	async mounted( )
	{
		try {
			this.editor = ace.edit( "editor", {
				mode: "ace/mode/json",
				theme: "ace/theme/tomorrow",	//"ace/theme/dracula",
				maxLines: 20,
				minLines: 5,
				fontSize: 14,
				showPrintMargin : false
			});
			this.editor.setValue( JSON.stringify( this.newProject, null, 2 ), -1 );
			this.listAccounts( { nodeId : this.nodeId } );
		} catch( err ) { throw err; }
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
	font-weight: normal;
}
div#editor
{
	border: 1px solid #666;
}
</style>


// WEBPACK FOOTER //
// src/components/Projects.vue